<script>
import {getUserContract, signContract} from "../../api/user";

export default {
  name: "SignDialog",
  props: {
    type: { type: String, default: "main" },
    show: { type: Boolean, default: false },
    sentType: { type: String, default: '' }
  },
  emits: ["close", "success"],
  computed: {
    user() {
      return this.$store.getters['user/user']
    },
  },
  data() {
    return {
      signing: false,
      signRequestSent: false,
      phone: '',
      error: ''
    }
  },
  methods: {
    async startSigning() {
      try {
        this.signing = true
        this.error = ''
        await signContract(this.type, this.phone)
        this.signRequestSent = true
        this.$emit('success')
      } catch (e) {
        if (e?.response?.data?.errors) {
          this.error = e.response.data.errors.phone?.[0]
            ?? e.response.data.errors.type?.[0]
            ?? 'Алдаа гарлаа'
        }
      } finally {
        this.signing = false
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.phone = ''
        this.error = ''
        this.signRequestSent = false
      }
    }
  }
}
</script>

<template>
  <ic-dialog :show="show">
    <div class="dialog-box">
      <a @click.stop="$emit('close')" class="icon-btn close-btn mr-row close-button">
        <i class='sr sr-close'></i>
      </a>
      <div class="contract-wrapper">
        <p class="text-center mb-20">
          {{ $t('sign_dialog.client_info') }}
        </p>
        <div class="d-flex justify-content-center">
          <ic-input disabled :placeholder="user.register_number.toUpperCase()" :text="'center'"
                   class="mr-lg-5 ml-lg-5 mb-20" style="max-width: 219px; max-height: 36px;"/>
        </div>
        <div class="mb-20 mt-20 desc-text">
          {{ $t('sign_dialog.register_hint') }} <br>
          {{ $t('sign_dialog.gsign_hint') }}
        </div>
        <label class="phone-input d-block mb-20" for="phone">
          <app-input id="number" :label="$t('sign_dialog.phone_label')" :placeholder="$t('sign_dialog.phone_label')"
                     prefix="(+976)" v-model="phone" type="number"/>
          <div v-if="error">
            <span class="error pt-2" style="color: red;">{{ error }}</span>
          </div>
        </label>
        <div v-if="signRequestSent && sentType === type" class="mb-20" style="color: #939393;">
          {{ $t('sign_dialog.sign_with_gsign') }}
        </div>
        <ic-button
          :disabled="phone === '' || phone.length !== 8 || (signRequestSent && sentType === type)"
          @click="startSigning"
          :loading="signing"
          block
          size="tn"
        >
          {{ $t('sign_dialog.confirm_with_digital_signature') }}
        </ic-button>
      </div>
    </div>
  </ic-dialog>
</template>

<style scoped lang="scss">
.dialog-box { position: relative; }
.contract-wrapper {
  max-width: 80vh;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.close-button { position: absolute; top: 6px; right: 0px; }
button { background: #0C293A !important; }
.desc-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #939393;
  text-align: center;
}
</style>